import { Box, Grid, Typography } from "@mui/material";
import { teamGradients } from "../../../../Utils/helperFunctions";

const PlayerSection: React.FC<any> = ({ teamDetails }) => {
  interface Player {
    soldTo?: string;
    photo: string;
    name?: string;
    soldToLogo?: string;
  }

  interface TransformedPlayer {
    logo: string;
    playerName: string;
    gradient: {
      from: string;
      to: string;
    };
    teamName: string;
  }

  const transformedPlayers: TransformedPlayer[] | undefined = teamDetails?.map(
    (player: Player) => {
      const gradient = teamGradients[player?.soldTo || ""] || {
        from: "#444",
        to: "#222",
      };
      return {
        logo: player?.photo,
        playerName: player?.name,
        gradient,
        teamName: player?.soldTo || "",
        teamLogo: player?.soldToLogo,
      };
    }
  );

  return (
    <Box height={"fit-content"} mt={"3vw"} width={"80%"}>
      <Grid
        container
        sx={{ width: "80%" }}
        columnSpacing={{ md: "1.5vw", xl: "1.5vw" }}
        rowSpacing={{ md: "3vw", xl: "3.5vw" }}
      >
        {transformedPlayers?.map((item, i) => (
          <Grid item key={i} xs={12} sm={6} md={4} lg={3}>
            <PlayerCard data={item} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

const PlayerCard: React.FC<any> = ({ data }) => {
  return (
    <Box
      sx={{
        position: "relative",
        borderRadius: ".3vw",
        // overflow: "hidden",
        // p: 2,
        display: "flex",
        justifyContent: "center",
        // alignItems: "center",
        background: `linear-gradient(to bottom, ${data.gradient.from}, ${data.gradient.to})`,
        height: "fit-content",
        minHeight: "12.5vw",
        maxWidth:"20vw"
      }}
    >
      <Box
        sx={{
          position: "absolute",
          zIndex: 3,
          textAlign: "center",
          top: "-2vw",
          backgroundColor: "#ffff",
          padding: "2px",
          width: "6vw",
          height: "6vw",
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
          borderRadius: "6vw",
          border: "5px solid #F47821",
          overflow: "hidden",
        }}
      >
        <img
          src={
            data?.logo ??
            "https://mcadirectory.blob.core.windows.net/dev/5543912493918424-avatar.png"
          }
          alt="Team Logo"
          width={100}
          height={100}
          style={{
            height: "6vw",
            width: "auto",
            margin: "0 auto",
            overflow: "hidden",
            transform: "scale(1.1)",
          }}
        />
      </Box>
      <Box
        mt={"5.5vw"}
        sx={{
          textAlign: "center",
          width: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography
          variant="h1"
          sx={{ fontSize: "1.2vw", fontWeight: 600 }}
          color="white"
        >
          {data?.playerName}
        </Typography>
        {data?.teamName && (
          <Box
            sx={{
              width: "100%",
              color: "#fff",
              display: "flex",
              gap: "0.8vw",
              marginTop: "auto",
              background:
                "linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.30) 50%, rgba(255, 255, 255, 0.00) 100%)",
            }}
          >
            <Box
              sx={{
                backgroundColor: "white",
                padding: "0.3vw",
                width: "3.6vw",
                height: "3.4vw",
                display: "flex",

                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={
                  data?.teamName == "Aakash Tigers MWS"
                    ? "https://turbostart.blob.core.windows.net/turbostart/48447191083078844-aakashTigers.png"
                    : data?.teamName == "Aakash Tigers MWS"
                    ? "https://turbostart.blob.core.windows.net/turbostart/48447191083078844-aakashTigers.png"
                    : data?.teamName == "Triumph Knights MNE"
                    ? "https://mcadirectory.blob.core.windows.net/dev/007792959990218895-triumphKnights.png"
                    : data?.teamLogo ||
                      "https://mcadirectory.blob.core.windows.net/dev/5543912493918424-avatar.png"
                }
                alt="Team Logo"
                width={100}
                height={100}
                style={{
                  height: "auto", // roughly h-28
                  width: "2.8vw",
                  margin: "0 auto",
                }}
              />
            </Box>
            <Typography
              variant="h4"
              sx={{
                fontSize: "1vw",
                fontWeight: 700,
                padding: "0.2vw 0",
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
                maxWidth: "70%",
                textAlign: "start",
                // alignItems: "start",
                // justifyContent: "start",
                width: "calc(100% - 3vw)",
                textTransform: "uppercase",
              }}
              color="white"
            >
              {data?.teamName}
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default PlayerSection;
